module.exports = __webpack_public_path__ + "static/img/hw.d2d1d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/hw.png
// module id = Ur7C
// module chunks = 1